export default __webpack_public_path__ + "static/media/Salient Features_USHPP_7.b62b9966.jpg";